import { render, staticRenderFns } from "./TemplateIcon.vue?vue&type=template&id=f20e92ea&"
import script from "./TemplateIcon.vue?vue&type=script&lang=js&"
export * from "./TemplateIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports